var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cost-estimate-container"},[_c('div',{staticClass:"section-title"},[_vm._v("总成本估算")]),_c('div',{staticClass:"component-content"},[_c('p',[_vm._v("总成本估算模块正在开发中...")])])])
}]

export { render, staticRenderFns }